// Global variables
window.KUtilElementDataStore = {};
window.KUtilElementDataStoreID = 0;
window.KUtilDelegatedEventHandlers = {};

let KUtil = function() {
    return {
        getUniqueId: function(prefix) {
            return prefix + Math.floor(Math.random() * (new Date()).getTime());
        },
        data: function(el) {
            return {
                set: function(name, data) {
                    if (!el) {
                        return;
                    }

                    if (el.customDataTag === undefined) {
                        window.KUtilElementDataStoreID++;
                        el.customDataTag = window.KUtilElementDataStoreID;
                    }

                    if (window.KUtilElementDataStore[el.customDataTag] === undefined) {
                        window.KUtilElementDataStore[el.customDataTag] = {};
                    }

                    window.KUtilElementDataStore[el.customDataTag][name] = data;
                },

                get: function(name) {
                    if (!el) {
                        return;
                    }

                    if (el.customDataTag === undefined) {
                        return null;
                    }

                    return this.has(name) ? window.KUtilElementDataStore[el.customDataTag][name] : null;
                },

                has: function(name) {
                    if (!el) {
                        return false;
                    }

                    if (el.customDataTag === undefined) {
                        return false;
                    }

                    return (window.KUtilElementDataStore[el.customDataTag] && window.KUtilElementDataStore[el.customDataTag][name]) ? true : false;
                },

                remove: function(name) {
                    if (el && this.has(name)) {
                        delete window.KUtilElementDataStore[el.customDataTag][name];
                    }
                }
            };
        },
        on: function(element, selector, event, handler) {
            if ( element === null ) {
                return;
            }

            let eventId = KUtil.getUniqueId('event');

            window.KUtilDelegatedEventHandlers[eventId] = function(e) {
                let targets = element.querySelectorAll(selector);
                let target = e.target;

                while ( target && target !== element ) {
                    for ( let i = 0, j = targets.length; i < j; i++ ) {
                        if ( target === targets[i] ) {
                            handler.call(target, e);
                        }
                    }

                    target = target.parentNode;
                }
            }

            KUtil.addEvent(element, event, window.KUtilDelegatedEventHandlers[eventId]);

            return eventId;
        },
        addEvent: function(el, type, handler) {
            if (typeof el !== 'undefined' && el !== null) {
                el.addEventListener(type, handler);
            }
        },
    }
}();

window.KUtil = KUtil;
